import z from 'zod';

export const dataSourceDataItemSchema = z.object({
	id: z.string(),
	name: z.string(),
});

export const dataSourceSchema = z
	.object({
		id: z.string(),
		name: z.string(),
		type: z.enum(['system', 'external', 'internal']),
		data: z.array(dataSourceDataItemSchema),
		url: z.string().optional(),
		createdAt: z.coerce.date(),
		updatedAt: z.coerce.date(),
	})
	.describe('DataSource');
